module.exports = __webpack_public_path__ + "img/science-fiction.37ff63f5.svg";